var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-tree"},[_c('el-tree',{ref:"menuTree",staticClass:"container",attrs:{"node-key":"menuId","show-checkbox":"","check-on-click-node":true,"default-checked-keys":_vm.checked,"data":_vm.menus,"indent":16,"props":{
        label: 'menuName'
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }